import { NEW_PATH_DELIMITER } from '@picsio/db/src/constants';

function matchesSavedSearchScope(ss, isShared) {
  if (isShared) return Boolean(ss.teamId);
  return !ss.teamId;
}

/**
 * Counts saved searches and direct child subgroups under `path` for the delete-group
 * confirmation copy. Scope matches `deleteGroup` / tree (personal vs team).
 *
 * @param {{ all: Array<{ path?: string, teamId?: unknown, isGroupPlaceholder?: boolean }>, path: string, isShared: boolean }} params
 * @returns {{ savedSearchCount: number, subgroupCount: number }}
 */
export default function getSavedSearchGroupDeleteImpactCounts({ all, path, isShared }) {
  const descendantPrefix = path + NEW_PATH_DELIMITER;
  const relevant = (all || []).filter((ss) => {
    if (!ss?.path || !ss.path.startsWith(descendantPrefix)) return false;
    return matchesSavedSearchScope(ss, isShared);
  });

  const savedSearchCount = relevant.filter((ss) => !ss.isGroupPlaceholder).length;

  const subgroupNames = new Set();
  relevant.forEach((ss) => {
    const relative = ss.path.slice(descendantPrefix.length);
    const parts = relative.split(NEW_PATH_DELIMITER).filter(Boolean);
    if (parts.length === 0) return;
    const child = parts[0];
    if (parts.length === 1) {
      if (ss.isGroupPlaceholder) subgroupNames.add(child);
    } else {
      subgroupNames.add(child);
    }
  });

  return { savedSearchCount, subgroupCount: subgroupNames.size };
}
